import "./src/styles/global.css"

export { wrapPageElement } from "./wrap-page-element"

// GA4 is configured with send_page_view:false, so emit a page_view on every
// route change (including the initial load). Consent Mode decides cookie use.
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    })
  }
}
